<template>
  <div>
    <el-row type="flex" style="text-align: center;margin-bottom: 2px;padding-bottom:2px ;border-bottom: 1px silver solid">
      <el-col :span="2">
        <el-tag effect="dark" size="small">题号</el-tag>
      </el-col>
      <el-col :span="4">
        <el-tag effect="dark" size="small">得分</el-tag>
      </el-col>
      <el-col :span="4">
        <el-tag effect="dark" size="small">解答</el-tag>
      </el-col>
      <el-col :span="4">
        <el-tag effect="dark" size="small">标答</el-tag>
      </el-col>
    </el-row>
    <el-row type="flex" v-for="(question,question_index) in question_group['questions']" :key="question_index"
            style="text-align: center;margin-bottom: 2px;padding-bottom:2px ;border-bottom: 1px silver solid">
      <el-col :span="2">
        <el-tag size="small" type="info" style="width: 45px">{{question.label}}</el-tag>
      </el-col>
      <el-col :span="4">
        <el-tag size="small" type="info" effect="dark" style="width: 45px">{{question.score}}</el-tag>
      
      </el-col>
      <el-col :span="4">
        <el-tag size="small" :type="check_answer(question)?'success':'danger'" effect="dark">
          {{get_answer(question_group.choices,question.answers)}}
        </el-tag>
      </el-col>
      <el-col :span="4">
        <el-tag size="small" type="success" effect="dark">{{get_answer(question_group.choices,question.check_answers)}}</el-tag>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "ChoiceScoreGroup",
    props: ["question_group"],
    methods: {
      check_answer(question) {
        let check_answers = question.check_answers
        let answers = question.answers
        if (check_answers.length !== answers.length) {
          return false
        } else {
          for (let _ in check_answers) {
            if (check_answers[_] !== answers[_]) {
              return false
            }
          }
        }
        return true
      },
      get_answer(a, b) {
        let out = ""
        for (let _ in a) {
          if (b[_]) {
            out = out + a[_]
          }
        }
        return out
      }
    }
  }
</script>

